import { render, staticRenderFns } from "./DeptUser.vue?vue&type=template&id=45486874&scoped=true"
import script from "./DeptUser.vue?vue&type=script&lang=js"
export * from "./DeptUser.vue?vue&type=script&lang=js"
import style0 from "./DeptUser.vue?vue&type=style&index=0&id=45486874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45486874",
  null
  
)

export default component.exports